import { render, staticRenderFns } from "./studentScore.vue?vue&type=template&id=8d231d48&"
import script from "./studentScore.vue?vue&type=script&lang=js&"
export * from "./studentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\atmolab_server_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d231d48')) {
      api.createRecord('8d231d48', component.options)
    } else {
      api.reload('8d231d48', component.options)
    }
    module.hot.accept("./studentScore.vue?vue&type=template&id=8d231d48&", function () {
      api.rerender('8d231d48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/coachmanage/teammanage/component/studentScore.vue"
export default component.exports